import type { DocumentSnapshot } from 'firebase/firestore'

export class MissingDocumentError extends Error {
  document: string

  constructor(snapshot: DocumentSnapshot | string, message?: string) {
    const ref = typeof snapshot === 'string' ? snapshot : snapshot.ref.path

    super(message ?? `Missing document ${ref}`)
    this.name = 'MissingDocumentError'

    this.document = ref
  }
}
